import classNames from 'classnames';
import React, { useEffect } from 'react';
import { IconCloseV2 } from '../Icons';
import { RADIUS_UNIT_TYPE, RadiusInput } from '../RadiusInput';

const Tag = (props) => {
  const [radius, setRadius] = React.useState<number>(1);
  const [radiusUnit, setRadiusUnit] = React.useState<any>('km');

  useEffect(() => {
    if (props.tag?.data?.context === 'address') {
      if (!!props.tag?.data?.circle?.radius != null) {
        if (props.tag?.data?.circle?.radiusUnit === RADIUS_UNIT_TYPE.KILO_METERS) {
          const a = props.tag?.data?.circle?.radius / 1000;
          setRadius(Number(a.toFixed(1)));
          setRadiusUnit(props.tag?.data?.circle?.radiusUnit || RADIUS_UNIT_TYPE.KILO_METERS);
        } else {
          setRadius(Number(props.tag?.data?.circle?.radius));
          setRadiusUnit(RADIUS_UNIT_TYPE.METERS);
        }
      }
    }
  }, [props?.tag]);

  const isAddressContext = () => {
    return props.tag?.data?.context === 'address' || props.tag?.group === 'address';
  };

  const changeTagRadius = (value) => {
    let tag = { ...props.tag };
    if (tag?.data) {
      tag.data.circle.radius = value;
      props.onChange(tag);
    }
  };

  const changeTagRadiusUnit = (value) => {
    let tag = { ...props.tag };
    if (tag?.data && value !== tag.data.circle.radiusUnit) {
      let radius = tag.data.circle.radius;
      if (tag.data.circle.radiusUnit === RADIUS_UNIT_TYPE.METERS && value === RADIUS_UNIT_TYPE.KILO_METERS) {
        radius = Number((radius / 1000).toFixed(1));
      }

      tag.data.circle.radius = radius;
      tag.data.circle.radiusUnit = value;
      props.onChange(tag);
    }
  };

  return (
    <button
      type='button'
      className={classNames(props.classNames.selectedTag, {
        'react-tags__selected-tag--highlighted': props.isHighlighted,
        'react-tags__selected-tag--has-radius': isAddressContext(),
        'react-tags__selected-tag--is-imported':
          props?.tag?.data?.types.includes('product_id') && props?.tag?.data?.types.indexOf('imported'),
      })}
      title={props.removeButtonText}
      onClick={props.onClick}
    >
      <div className='button-content'>
        <div className='address-wrap'>
          <div className={props.classNames.selectedTagName}>
            <div className='icon'>{props.tagIcon}</div>
            <div className='location-name'>{props.tag.name}</div>
          </div>

          {isAddressContext() && (
            <RadiusInput
              radius={radius}
              setRadius={changeTagRadius}
              radiusUnit={radiusUnit}
              setRadiusUnit={changeTagRadiusUnit}
              kilometersLabel={props.kilometersLabel}
              metersLabel={props.metersLabel}
              radiusLabel={props.radiusLabel}
            />
          )}
        </div>

        <div onClick={props.onDelete} className='tag-close-icon'>
          <IconCloseV2 />
        </div>
      </div>
    </button>
  );
};

export default Tag;
